const API_ROTA = `${window.location.protocol}//${window.location.host}/barbearia`
// const API_ROTA = 'https://sistema.stnbarbearia.com.br/barbearia'

export default API_ROTA
